import { DesignEvent } from "../../../../../base/models"
import { DesignerMode } from "../../../../types"
import { DndContextProvider } from "../../../../dnd/DndContextProvider"
import { FC } from "react"
import { IPage } from "../../../models"
import { LayoutControlCollection } from "../../../../page-control"
import { ViewPageControls } from "../../../page/components/ViewPageControls"

interface IPageControlsViewSwitchProps {
    page: IPage,
    editMode: DesignerMode,
    onDesignChange: (event: DesignEvent) => void
}

export const PageControlsViewSwitch: FC<IPageControlsViewSwitchProps> = ({
    page, editMode, onDesignChange
}) => {
    const getComponent = () => {
        switch (editMode) {
            case DesignerMode.Draft:
                return <DndContextProvider>
                    <LayoutControlCollection
                        controls={page.controls || []}
                        onDesignChange={onDesignChange} />
                </DndContextProvider>
            case DesignerMode.View:
                return <ViewPageControls controls={page.controls} />
        }
    }

    return <div className="position-relative">
        {getComponent()}
    </div>
}